import {
  getPreferences,
  setIsDeskRequired,
  setParkingLocation,
  setWorkspaceLocation,
  useAppDispatch,
  useAppSelector,
} from '@lib/store';
import {useEffect} from 'react';

export const useSetInitialOnboardingState = () => {
  const dispatch = useAppDispatch();
  const {workspaceLocation, parkingLocation} = useAppSelector(getPreferences);

  useEffect(() => {
    // Set initial onboarding state if user already has some preferences
    if (workspaceLocation !== null) {
      const {floorId, areaId, deskAmenities, isDeskRequired} = workspaceLocation;
      dispatch(setWorkspaceLocation({floorId, areaId, deskAmenities}));
      dispatch(setIsDeskRequired(!!isDeskRequired));
    }

    if (parkingLocation !== null) {
      const {parkingLotId, parkingZoneId} = parkingLocation;
      dispatch(setParkingLocation({parkingLotId, parkingZoneId}));
    }
  }, [dispatch, parkingLocation, workspaceLocation]);
};
